import React from "react";

const Billingbanner = () => {
  const bannerStyles = {
   // marginTop: "60px",
    width: "100%",
    height: "90vh",
    backgroundImage: "url('/image/lsg-blog-jan-2020-1.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    textAlign: "left",
    color: "white",
    position: "relative",
    overflow: "hidden",
    fontFamily: "Arial, sans-serif",
    paddingLeft: "8%",
  };

  const contentStyles = {
    maxWidth: "700px",
    padding: "0 20px",
    animation: "slideUp 1.5s ease-out forwards",
    opacity: 0,
    marginBottom: "-260px",
  };

  const headingStyles = {
    fontSize: "2rem",
    margin: 0,
    lineHeight: 1.2,
    fontWeight: "bold",
    textShadow: "2px 2px 5px rgba(0,0,0,0.6)",
    color: "white",
    letterSpacing: "0px",
  };

  const paragraphStyles = {
    fontSize: "1.5rem",
    marginTop: "1rem",
    textShadow: "1px 1px 4px rgba(0,0,0,0.5)",
    textAlign: "justify",
  };

  return (
    <>
      <style>
        {`
          @keyframes slideUp {
            0% {
              transform: translateY(50px);
              opacity: 0;
            }
            100% {
              transform: translateY(0);
              opacity: 1;
            }
          }

          /* Responsive styles */
          @media (max-width: 1200px) {
            h1 {
              font-size: 1.5rem !important;
            }
            p {
              font-size: 1rem !important;
            }
          }
          @media (max-width: 768px) {
            h1 {
              font-size: 1.5rem !important;
            }
            p {
              font-size: 1rem !important;
            }
          }
          @media (max-width: 480px) {
            h1 {
              font-size: 1rem !important;
            }
            p {
              font-size: 1rem !important;
            }
          }
        `}
      </style>

      <div style={bannerStyles}>
        <div style={contentStyles}>
          <h1 style={headingStyles}>
            Simplify Your Finances with Our Billing System
          </h1>
          <p style={paragraphStyles}>
            Automate invoicing, track payments, and manage accounts effortlessly
            — all in one secure platform.
          </p>
        </div>
      </div>
    </>
  );
};

export default Billingbanner;
